// extracted by mini-css-extract-plugin
export default {"Box":"label-group-module__Box--YquYy"};